export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=407b8070df759b18fc7f4311ab0b02edfd3d6d6e4f&name=revalidateCommunity!'